var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../config/request';
export const fetchUserInfo = createAsyncThunk('user-info/fetch', (user, thunkApi) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { id_avn_user, id_user, id_role } = user;
        const { data } = yield request(`/user?id_user=${id_user}&id_avn=${id_avn_user}&id_role=${id_role}`);
        const { name, name_group, surname, id_group, AVN_login, patronymic } = data;
        return {
            AVN_login: AVN_login,
            surname: surname,
            name: name,
            patronymic: patronymic,
            name_group: name_group,
            id_group
        };
    }
    catch (e) {
        return thunkApi.rejectWithValue('Ошибка');
    }
}));
